import styled from 'styled-components';
interface IDrawerContentBoxProps {
    visible: boolean;
}
export const DrawerContentBox = styled.div<IDrawerContentBoxProps>`
  display: ${props => props.visible ? 'block' : 'none'};
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;
